import moment, { Moment } from "moment";
import { moduleSettings } from "../stores/module-settings.store";
import { selectionStore } from "../stores/selection.store";
import { requestParamsImpl } from "./request-params.service";

class SelectionCalendarDate {
  static service: SelectionCalendarDate | undefined;
  static get(): SelectionCalendarDate {
    if (!this.service) {
      this.service = new SelectionCalendarDate();
    }
    return this.service!;
  }

  computeDefaultDate(): Moment | undefined {
    const bookingDate = moduleSettings.bookingDate;
    const overwrittenDate = requestParamsImpl.overwrittenDate();
    return bookingDate
      ? bookingDate
      : overwrittenDate
      ? overwrittenDate
      : undefined;
  }
  setDefaultDate() {
    let defaultDate: Moment | undefined = this.computeDefaultDate();
    selectionStore.date = defaultDate;
    selectionStore.calendarDate = defaultDate
      ? defaultDate
      : moment().startOf("month");
  }
  computeDefaultTime(): string | undefined {
    const bookingTime = moduleSettings.bookingTime;
    const overwrittenTime = requestParamsImpl.overwrittenTime();
    return bookingTime
      ? bookingTime
      : overwrittenTime
      ? overwrittenTime
      : undefined;
  }
  setDefaultTime() {
    let defaultTime: string | undefined = this.computeDefaultTime();
    if(defaultTime) {
      selectionStore.time = defaultTime;
    }
  }
}

export default SelectionCalendarDate.get();
